// Boardwalk test/debug flags (?bwtest=1, ?bw_debug=...) are captured once on app load and kept
// in memory: funnel navigation rewrites the URL and ClearUserRegister wipes sessionStorage.
const DEBUG_PARAM_KEYS = ['bwtest', 'bw_debug'];

let capturedParams: Record<string, string> = {};

export function captureBoardwalkDebugParams(search: string = window.location.search): void {
  const query = new URLSearchParams(search);
  DEBUG_PARAM_KEYS.forEach((key) => {
    const value = query.get(key);
    if (value) {
      capturedParams[key] = value;
    }
  });
}

export function getBoardwalkDebugParams(): Record<string, string> {
  return { ...capturedParams };
}

// Test-only reset of the module state.
export function resetBoardwalkDebugParams(): void {
  capturedParams = {};
}
